module.exports = __webpack_public_path__ + "static/logo-android-6a723bda165a80530b57b50cf272ba91.png";